import {
  AggregatedInventoryArticle,
  CardDataItem,
  FINISH_TYPE_LABELS,
  InventoryArticle,
  PTInventoryProduct,
} from 'shared'

export const getInventoryArticle = (ptInventoryProduct: PTInventoryProduct) => {
  const params = {
    id: ptInventoryProduct._id.toString(),
    quantity: ptInventoryProduct.quantity,
    price: 10,
    card: {
      _id: ptInventoryProduct._id,
      rarity: 0,
      rarityStr: 'bla',
      categoryName: ptInventoryProduct.categoryName,
      cn: null,
      name: '',
      set: ptInventoryProduct.expansion?.code ?? '',
      expansion: '',
      locNames: {
        ['DE']: '',
        IT: '',
        FR: '',
        ES: '',
      },
    },
  }
  const inventoryArticle = new InventoryArticle(params)
  inventoryArticle.condition = ptInventoryProduct.condition
  inventoryArticle.idLanguage = ptInventoryProduct.idLanguage
  return inventoryArticle
}

export const findAggregatedInventoryArticle = (
  aggregatedStock: AggregatedInventoryArticle[],
  article: InventoryArticle
) => {
  const foundArticle = aggregatedStock.find((aggregatedArticle: AggregatedInventoryArticle) => {
    const { idProduct, idLanguage, condition, isSigned, isFirstEd, finishType } = article
    return (
      aggregatedArticle.idProduct === idProduct &&
      aggregatedArticle.idLanguage === idLanguage &&
      aggregatedArticle.condition === condition &&
      aggregatedArticle.isSigned === isSigned &&
      aggregatedArticle.isFirstEd === isFirstEd &&
      aggregatedArticle.finishType === finishType
    )
  })
  return foundArticle
}

export const HOTKEY_ATTRIBUTE_CONFIG = {
  isFoil: {
    toggle: true,
    mapsTo: 'finishType',
  },
  isReverseHolo: {
    toggle: true,
    mapsTo: 'finishType',
  },
  isColdFoil: {
    toggle: true,
    mapsTo: 'finishType',
  },
  isRainbowFoil: {
    toggle: true,
    mapsTo: 'finishType',
  },
  isFirstEd: { toggle: true },
  isSigned: { toggle: true },
}

export const initializeFinishTypeAccordingCardNameOrFoil = (card: CardDataItem) => {
  let finishType = FINISH_TYPE_LABELS.REGULAR
  if (card.onlyFoil) {
    finishType = FINISH_TYPE_LABELS.FOIL
  } else if (card.name?.toLocaleLowerCase().includes('rainbow foil')) {
    finishType = FINISH_TYPE_LABELS.RAINBOW_FOIL
  } else if (card.name?.toLocaleLowerCase().includes('cold foil')) {
    finishType = FINISH_TYPE_LABELS.COLD_FOIL
  } else if (card?.name.toLocaleLowerCase().includes('reverse holo')) {
    finishType = FINISH_TYPE_LABELS.REVERSE_HOLO
  }
  return finishType
}

export const waitForSelector = (selector: string, timeoutMs = 4000) =>
  new Promise<boolean>((resolve) => {
    const found = () => !!document.querySelector(selector)
    if (found()) return resolve(true)

    const obs = new MutationObserver(() => {
      if (found()) {
        obs.disconnect()
        resolve(true)
      }
    })
    obs.observe(document.body, { childList: true, subtree: true })

    setTimeout(() => {
      obs.disconnect()
      resolve(found())
    }, timeoutMs)
  })
